// Sidebar page /api-keys: the account's API keys (administrators; others are sent back to the list).

import { useHostContext } from '@waforms/app-sdk/client';
import { Button, EmptyState, PageHeader } from '@waforms/ui';
import { ArrowLeft, Lock } from 'lucide-react';
import { useNavigate } from 'react-router';
import { ApiKeysCard } from '../components/ApiKeys.tsx';
import { publicApiUrl } from '../lib/public-api.ts';

export function ApiKeysPage() {
  const host = useHostContext();
  const navigate = useNavigate();
  const isAdmin = host.currentAgent?.role === 'administrator';
  return (
    <div className="mx-auto flex w-full max-w-6xl flex-col px-6 py-6">
      <PageHeader
        title="API keys"
        description="Keys for the WhatsApp Forms API, for servers you control."
        actions={
          <Button
            variant="faded"
            color="slate"
            size="sm"
            icon={<ArrowLeft className="size-4" />}
            onClick={() => void navigate('/')}
          >
            Forms
          </Button>
        }
      />
      {isAdmin ? (
        <ApiKeysCard apiUrl={publicApiUrl()} />
      ) : (
        <EmptyState
          icon={<Lock />}
          title="Administrators only"
          description="Ask an administrator for an API key."
        />
      )}
    </div>
  );
}
